function addSwipeEvent(targetID, handler) {

  let target = document.getElementById(targetID);

  if (target) {
    target.addEventListener('touchstart', handleTouchStart, false);
    target.addEventListener('touchmove', handleTouchMove, false);
  }

  var xDown = null;
  var yDown = null;

  function handleTouchStart(evt) {
      xDown = evt.touches[0].clientX;
      yDown = evt.touches[0].clientY;
  };

  function handleTouchMove(evt) {
      if ( ! xDown || ! yDown ) {
          return;
      }

      var xUp = evt.touches[0].clientX;
      var yUp = evt.touches[0].clientY;

      var xDiff = xDown - xUp;
      var yDiff = yDown - yUp;

      if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {/*most significant*/
          if ( xDiff > 0 ) {
              jQuery('.right').click();
          } else {
              jQuery('.left').click();
          }
      } else {
          if ( yDiff > 0 ) {
              /* up swipe */
          } else {
              /* down swipe */
          }
      }
    /* reset values */
    xDown = null;
    yDown = null;
  }

}

window.addEventListener('load', function() {
  addSwipeEvent('icon-carousel');
});
